import { useAtomValue } from 'jotai';
import React__default from 'react';
import { isAnyGuardLoadingAtom } from '../../components/loadingAtoms.js';
import './LoadingPage.scss';

/**
 * Global loading page that displays when any guard is loading
 * This component stays mounted and only shows/hides based on loading state,
 * ensuring the loading animation is never interrupted
 */
const LoadingPage = () => {
    const isLoading = useAtomValue(isAnyGuardLoadingAtom);
    if (!isLoading) {
        return null;
    }
    return (React__default.createElement("div", { className: 'loading-page' },
        React__default.createElement("div", { className: 'loading-page-container' },
            React__default.createElement("div", { className: 'loading-page-spinner' }))));
};

export { LoadingPage };
//# sourceMappingURL=LoadingPage.js.map
